import React from "react";
import { Box, Card } from "@bca/ui-library";
import { layout, LayoutProps } from "styled-system";
import styled from "styled-components";

import AnimatedBox from "./AnimatedBox";

const StyledCard = styled(Card)<LayoutProps>`
  ${layout}
`;

const TabletSkeletonCard = ({
  display,
}: {
  display?: LayoutProps["display"];
}) => (
  <StyledCard
    width="auto"
    height="324px"
    paddingX={0}
    paddingY={0}
    marginX={0}
    marginY={0}
    display={display}
    data-testid="container"
  >
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      width="auto"
      height="inherit"
      data-testid="container2"
    >
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        width="auto"
      >
        <AnimatedBox
          width="210px"
          height="211px"
          data-testid="image-skel"
          borderTopRightRadius="0px"
          borderBottomRightRadius="0px"
        />
        <Box
          data-testid="middle-skel"
          display="flex"
          flexDirection="column"
          flex="1 0 auto"
          padding={4}
          mb="43px"
        >
          <AnimatedBox width="112px" height="23px" mb="43px" />
          <AnimatedBox maxWidth="428px" width="auto" height="16px" mb="43px" />
          <Box display="flex" flexDirection="row" mb={9}>
            <Box
              display="flex"
              flexDirection="row"
              css={`
                @media screen and (min-width: 470px) and (max-width: 700px) {
                  flex-direction: column;
                }
              `}
              mb="10px"
            >
              <Box
                css={`
                  @media screen and (min-width: 470px) and (max-width: 700px) {
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    align-items: center;
                    width: 105px;
                  }
                `}
              >
                <AnimatedBox width="18px" height="18px" />
                <AnimatedBox width="80px" height="13px" my="9px" mr={5} />
              </Box>
              <Box
                css={`
                  @media screen and (min-width: 470px) and (max-width: 700px) {
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    align-items: center;
                    width: 105px;
                  }
                `}
              >
                <AnimatedBox width="18px" height="18px" />
                <AnimatedBox width="80px" height="13px" my="9px" mr={5} />
              </Box>
            </Box>
            <Box
              display="flex"
              flexDirection="row"
              css={`
                @media screen and (min-width: 470px) and (max-width: 700px) {
                  flex-direction: column;
                  display: none;
                }
              `}
              mb="20px"
            >
              <Box>
                <AnimatedBox width="18px" height="18px" />
                <AnimatedBox width="80px" height="13px" my="9px" mr={5} />
              </Box>
              <Box>
                <AnimatedBox width="18px" height="18px" />
                <AnimatedBox width="80px" height="13px" my="9px" />
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
      <Box
        backgroundColor="rgba(190, 191, 190, 0.1)"
        padding={4}
        display="flex"
        alignItems="flex-end"
        width="auto"
        height="60px"
        data-testid="end-skel"
      ></Box>
    </Box>
  </StyledCard>
);

export default TabletSkeletonCard;
